import cc from 'classcat';

import styles from './styles.module.scss';

const CardGroup = ({ className, children }) => (
  <div className={cc([styles.container, className])}>{children}</div>
);

export default CardGroup;
